export default __webpack_public_path__ + "329b1a60cda8f1ca625266611ea9bded.woff2";